import { TradeEnum } from "./enums";

export const LANDING_ROUTE = "/";
export const SIGN_IN_ROUTE = "/sign-in";

// Auth
export const SIGNUP_ROUTE = "/sign-up";

// Accounts
export const ACCOUNTS_ROUTE = "/accounts";
export const CREATE_ACCOUNT_ROUTE = `${ACCOUNTS_ROUTE}/create-account`;
export const ACCOUNT_SWAP_FREE_ROUTE = `${ACCOUNTS_ROUTE}/swap-free`;

// KYC
export const KYC_ROUTE = "/kyc";

// PROFILE
export const PROFILE_ROUTE = "/profile";

// SETTINGS
export const SETTINGS_ROUTE = "/settings";
export const CHANGE_PASSWORD_ROUTE = `${SETTINGS_ROUTE}/change-password`;
export const PAYMENTS_ROUTE = `${SETTINGS_ROUTE}/payments`;
export const ADD_FUNDS_ROUTE = `${PAYMENTS_ROUTE}/add-funds`;
export const WITHDRAW_ROUTE = `${PAYMENTS_ROUTE}/withdraw`;
export const TRANSFER_ROUTE = `${PAYMENTS_ROUTE}/transfer`;

// TRANSACTIONS
export const TRANSACTION_ROUTE = "/transactions";

// DOCUMENTS
const LEGAL_DOCUMENT_ROUTES = "/legal-documents";
export const RISK_DISCLOSURE_AGREEMENT_ROUTE = `${LEGAL_DOCUMENT_ROUTES}/risk-disclosure-agreement`;
export const TERMS_AND_CONDITIONS_ROUTE = `${LEGAL_DOCUMENT_ROUTES}/terms-and-conditions`;
export const PRIVACY_POLICY_ROUTE = `${LEGAL_DOCUMENT_ROUTES}/privacy-policy`;

// Trading
export const TRADE_ROUTE = "/trade";
export const TRADE_MT5_ROUTE = `${TRADE_ROUTE}/${TradeEnum.MT5}`;
export const TRADE_LITE_ROUTE = `${TRADE_ROUTE}/${TradeEnum.Lite}`;
export const TRADE_PRO_ROUTE = `${TRADE_ROUTE}/${TradeEnum.Pro}`;

// Home
export const HOME_ROUTE = "/home";

// INTRODUCING BROKER
export const INTRODUCING_BROKER_ROUTE = "/introducing-broker";
export const INTRODUCING_BROKER_APPLY_ROUTE = `${INTRODUCING_BROKER_ROUTE}/apply`;
export const INTRODUCING_BROKER_DASHBOARD_ROUTE = `${INTRODUCING_BROKER_ROUTE}/dashboard`;
export const INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE = `${INTRODUCING_BROKER_ROUTE}/account-commission`;
export const INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE = `${INTRODUCING_BROKER_ROUTE}/client-commission`;
export const INTRODUCING_BROKER_LINKS_ROUTE = `${INTRODUCING_BROKER_ROUTE}/links`;
export const INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE = `${INTRODUCING_BROKER_ROUTE}/commission-settings`;
export const INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE = `${INTRODUCING_BROKER_ROUTE}/ib-commissions`;
export const INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE = `${INTRODUCING_BROKER_ROUTE}/performance-dashboard`;

// NEWS
export const NEWS_ROUTE = "/news";

// ONBOARDING
const ONBOARDING_ROUTE = "/onboarding";
export const ONBOARDING_KYC_ROUTE = `${ONBOARDING_ROUTE}/kyc-documents`;
export const ONBOARDING_SUITABILITY_ROUTE = `${ONBOARDING_ROUTE}/suitability`;
export const ONBOARDING_CREATE_ACCOUNT_ROUTE = `${ONBOARDING_ROUTE}/create-account`;
export const ONBOARDING_FUNDING_ROUTE = `${ONBOARDING_ROUTE}/funding`;
export const ONBOARDING_COMPLETE_ROUTE = `${ONBOARDING_ROUTE}/complete`;

// COPY TRADING
export const COPY_TRADING_ROUTE = "/copy-trading";
export const COPY_TRADING_MY_PROVIDER_PORTFOLIO_ROUTE =
  "/copy-trading/my-provider-portfolio";
export const COPY_TRADING_MY_PROVIDER_PORTFOLIO_EDIT_ROUTE =
  "/copy-trading/my-provider-portfolio/edit";
export const COPY_TRADING_PROVIDER_DETAILS_ROUTE = "/copy-trading/provider";
export const COPY_TRADING_MY_SUBSCRIPTIONS_ROUTE =
  "/copy-trading/my-subscriptions";
export const COPY_TRADING_MY_SUBSCRIPTIONS_DETAILS_ROUTE =
  "/copy-trading/my-subscriptions/details";
